// extracted by mini-css-extract-plugin
export default {"ResponsiveFrame":"VideoFrame_ResponsiveFrame__x3Rx6"};